import React from 'react';
import { RiskRating } from '../../components';

import Tooltip from '../../components/Tooltip';
import { EllipsisLabel } from './styled';
import { convertISOToDateFormat } from '../../../../util/timezone';
import { floor } from '../../../../util/lodashlike';

export default {
  defaultProperties: {
    render: (text) => (text ? text : '-')
  },
  customProperties: {
    linkedPartyKey: {
      ellipsis: true,
      render: (text) => <EllipsisLabel>{text}</EllipsisLabel>
    },
    partyName: {
      ellipsis: true,
      render: (text) => <EllipsisLabel>{text}</EllipsisLabel>
    },
    riskRating: {
      render: (text) => <RiskRating value={text} />
    },
    primaryPartyKey: {
      render: (text) => <b>{text}</b>
    },
    shareholderPercentage: {
      render: (text) =>
        text ? <Tooltip content={text}>{floor(text, 2)}</Tooltip> : '-'
    },
    dobOrIncorporationDate: {
      render: (text) => (text ? convertISOToDateFormat(text) : '-')
    }
  }
};
